import { ApplicationAssetResponse } from '@core/services/dto/application-asset-response.dto';

export class ApplicationAssetModel {
  assetId: number;
  applicantId: number;
  assetType: string;
  description: string;
  primaryResidence?: any;
  propertyType?: string;
  mpacAssessmentValue?: number;
  marketValue?: number;
  streetNumber?: string;
  streetName?: string;
  suiteNumber?: string;
  city?: string;
  province?: string;
  postalCode?: string;
  mortgageOnProperty?: any;
  currentBalance?: number;
  paymentAmount?: number;
  paymentFrequency: string;
  financialInstitution: string;
  maturityDate?: string;
  paymentIncludeTaxes?: boolean;
  annualPropertyTax?: number;
  vehicleMake: string;
  vehicleYear?: number;
  vehicleModel: string;
  condoFees?: number;
  isRegisteredInvestment?: boolean;
  heatingCosts?: number;
  useAsCollateral?: boolean;
  vehicleLoanLease?: number;
  monthlyPayment?: number;
  isExistingCollateral: boolean;
  appraisal?: number;
  provinceId?: number;
  countryId?: number;
  nonRegisteredRetailInvestmentName: string;
  nonRegisteredRetailInvestmentType?: any;
  numberOfShares?: number;
  stockType?: number;
  stockSymbol: string;
  numberOfUnits?: number;
  fundCode: string;
  parValue?: number;
  couponRate?: number;
  gicType: string;
  gicNumber: string;
  depositHeldAtFI?: boolean;
  holdAmount?: number;
  existingAccountNumber?: number;
  hasSellingProperty?: boolean;
  hasBeingRefinanced?: any;
  hasBeingRenewed?: boolean;
  keepAssetOnFile?: boolean;
  percentage?: number;
  isPurchased?: boolean;
  collateralCode: string;
  mortgageAccountNo: string;
  vehicleIdentificationNumber: string;
  referenceNo: string;
  tfsaInvestment?: boolean;
  beneficiaryName: string;
  investmentOrRentalProperty?: any;
  insuranceCosts?: number;
  additionalUtilityOrCosts?: number;
  annualRentalIncome?: number;
  rentalIncomePercentage?: number;
  annualRentalIncomeValue?: number;
  fhsaInvestment?: boolean;
  createDate: string;
  lastModifiedDate?: string;

  constructor(dto: ApplicationAssetResponse) {
    this.assetId = dto.assetId;
    this.applicantId = dto.applicantId;
    this.assetType = dto.assetType || '';
    this.description = dto.description || '';
    this.primaryResidence = dto.primaryResidence;
    this.propertyType = dto.propertyType;
    this.mpacAssessmentValue = dto.mpacAssessmentValue;
    this.marketValue = dto.marketValue;
    this.streetNumber = dto.streetNumber;
    this.streetName = dto.streetName;
    this.suiteNumber = dto.suiteNumber;
    this.city = dto.city;
    this.province = dto.province;
    this.postalCode = dto.postalCode;
    this.mortgageOnProperty = dto.mortgageOnProperty;
    this.currentBalance = dto.currentBalance;
    this.paymentAmount = dto.paymentAmount;
    this.paymentFrequency = dto.paymentFrequency || '';
    this.financialInstitution = dto.financialInstitution || '';
    this.maturityDate = dto.maturityDate;
    this.paymentIncludeTaxes = dto.paymentIncludeTaxes;
    this.annualPropertyTax = dto.annualPropertyTax;
    this.vehicleMake = dto.vehicleMake || '';
    this.vehicleYear = dto.vehicleYear;
    this.vehicleModel = dto.vehicleModel || '';
    this.condoFees = dto.condoFees;
    this.isRegisteredInvestment = dto.isRegisteredInvestment;
    this.heatingCosts = dto.heatingCosts;
    this.useAsCollateral = dto.useAsCollateral;
    this.vehicleLoanLease = dto.vehicleLoanLease;
    this.monthlyPayment = dto.monthlyPayment;
    this.isExistingCollateral = dto.isExistingCollateral ?? false;
    this.appraisal = dto.appraisal;
    this.nonRegisteredRetailInvestmentName = dto.nonRegisteredRetailInvestmentName || '';
    this.nonRegisteredRetailInvestmentType = dto.nonRegisteredRetailInvestmentType;
    this.numberOfShares = dto.numberOfShares;
    this.stockType = dto.stockType;
    this.stockSymbol = dto.stockSymbol || '';
    this.numberOfUnits = dto.numberOfUnits;
    this.fundCode = dto.fundCode || '';
    this.parValue = dto.parValue;
    this.couponRate = dto.couponRate;
    this.gicType = dto.gicType || '';
    this.gicNumber = dto.gicNumber || '';
    this.depositHeldAtFI = dto.depositHeldAtFI;
    this.holdAmount = dto.holdAmount;
    this.existingAccountNumber = dto.existingAccountNumber;
    this.hasSellingProperty = dto.hasSellingProperty;
    this.hasBeingRefinanced = dto.hasBeingRefinanced;
    this.hasBeingRenewed = dto.hasBeingRenewed;
    this.keepAssetOnFile = dto.keepAssetOnFile;
    this.percentage = dto.percentage;
    this.isPurchased = dto.isPurchased;
    this.collateralCode = dto.collateralCode || '';
    this.mortgageAccountNo = dto.mortgageAccountNo || '';
    this.vehicleIdentificationNumber = dto.vehicleIdentificationNumber || '';
    this.referenceNo = dto.referenceNo || '';
    this.tfsaInvestment = dto.tfsaInvestment;
    this.beneficiaryName = dto.beneficiaryName || '';
    this.investmentOrRentalProperty = dto.investmentOrRentalProperty;
    this.insuranceCosts = dto.insuranceCosts;
    this.additionalUtilityOrCosts = dto.additionalUtilityOrCosts;
    this.annualRentalIncome = dto.annualRentalIncome;
    this.rentalIncomePercentage = dto.rentalIncomePercentage;
    this.annualRentalIncomeValue = dto.annualRentalIncomeValue;
    this.fhsaInvestment = dto.fhsaInvestment;
    this.createDate = dto.createDate || new Date().toISOString();
    this.lastModifiedDate = dto.lastModifiedDate;
    this.provinceId = dto.provinceId;
    this.countryId = dto.countryId;
  }
}
